<app-data (technicianApplicationDataChange)="updateApplicationData($event)" [dataObject]="dataObject"></app-data>
<div class="overview-details-section">
  <div class="overview-details-container">
    <span *ngIf="technicianRole === userRoles.standardTechnician || technicianRole === userRoles.guestTechnician">
      <ng-container *ngFor="let item of detailsData.staticData.leftPanel">
        <div class="overview-details-title">{{ 'overview.details-data.section-titles.' + item.id | translate }}</div>
        <hr class="title-underline" />

        <div *ngFor="let object of item.data; let index = index" class="details-row">
          <div class="row-documents-label">
            {{ 'overview.details-data.data-rows.' + object.field | translate }}
          </div>
          <div class="details-view-button">
            <button
              (click)="downloadFile(object.name)"
              class="view-btn-width"
              id="doc-download-btn-{{ index }}"
              label="{{ 'view-button-label' | translate }}"
              pButton
              type="button"></button>
          </div>
        </div>
      </ng-container>

      <ng-container>
        <div class="overview-details-title">{{ 'overview.details-data.section-titles.other-documents' | translate }}</div>
        <hr class="title-underline" />
        <div *ngFor="let object of documentsData; let index = index">
          <div
            *ngIf="
              object.name !== fileData.BUSINESSREGISTRATION &&
              object.name !== fileData.PROOFOFQUALIFICATION &&
              object.name !== fileData.PROOFOFEXPERTISE &&
              object.name !== fileData.PROOFOFCONTRACT &&
              object.name !== fileData.ENTRYINTRADEREGISTER &&
              object.name !== fileData.ENTRYATCHAMBEROFHANDICRAFTS &&
              object.name !== fileData.PROOFOFINDEMNITYINSURANCE &&
              object.name !== fileData.PROOFOFVDESUBSCRIPTION &&
              object.name !== fileData.WELDINGCERTIFICATECONFIRMATION
            ">
            <div class="details-row">
              <div class="row-documents-label">{{ getOtherDocumentLabel(object.name) }}</div>
              <div class="details-view-button">
                <button
                  (click)="downloadFile(object.name)"
                  [disabled]="checkForAvailableDocuments(object.name)"
                  class="view-btn-width"
                  id="other-doc-download-btn-{{ index }}"
                  label="{{ 'view-button-label' | translate }}"
                  pButton
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </span>
  </div>
  <div class="overview-details-container">
    <form *ngIf="detailsFormGroup" [formGroup]="detailsFormGroup">
      <ng-container *ngFor="let item of detailsData.staticData.rightPanel">
        <span *ngIf="!isReadOnly || (isReadOnly && item.id !== 'licensing')">
          <div class="overview-details-title">{{ 'overview.details-data.section-titles.' + item.id | translate }}</div>
          <hr class="title-underline" />
        </span>

        <div *ngIf="item.id === 'network-permissions'">
          <div class="details-form-row">
            <div *ngFor="let object of item.data; let checkboxId = index">
              <p-checkbox
                appEnterClick
                [formControlName]="object.field"
                binary="true"
                id="details-checkbox-{{ checkboxId }}"
                label="{{ 'overview.details-data.data-rows.' + object.field | translate }}"></p-checkbox>
            </div>
          </div>
          <ng-container *ngIf="detailsData.tabIndex === 3">
            <div class="overview-details-title">{{ 'overview.details-data.section-titles.role' | translate }}</div>
            <hr class="title-underline" />
            <div class="field-rows">
              <div class="ui-g-6 p-field-radiobutton">
                <p-radioButton formControlName="role" name="role" value="standard_technician" class="radio"></p-radioButton>
                <label>{{ 'app.user-form.standard-technician' | translate }}</label>
              </div>
              <div class="ui-g-6 p-field-radiobutton">
                <p-radioButton formControlName="role" name="role" value="guest_technician"></p-radioButton>
                <label>{{ 'app.user-form.guest-technician' | translate }}</label>
              </div>
            </div>
          </ng-container>

          <div *ngFor="let object of documentsData; let index = index">
            <div *ngIf="object.name === 'welding_certificate_confirmation'" class="network-document-row">
              <div class="row-documents-label">
                {{ 'basic-profile.fields.' + object.name | translate }}
              </div>
              <div class="details-view-button">
                <button
                  (click)="downloadFile(object.name)"
                  [disabled]="checkForAvailableDocuments(object.name)"
                  class="view-btn-width"
                  id="docs-permission-download-btn"
                  label="{{ 'view-button-label' | translate }}"
                  pButton
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="item.id === 'licensing' && !isReadOnly">
          <div *ngIf="detailsFormGroup.get('registeredNetworkOperator')" class="network-operator-row">
            <label class="ui-g-5" for="details-input-werkstattprufung">
              {{ 'basic-profile.fields.workshop_inspection_passed_at' | translate }}
            </label>
            <input
              class="h4-button-and-field ui-input pInputText filed-width"
              formControlName="registeredNetworkOperator"
              id="details-input-werkstattprufung"
              pInputText
              size="30"
              type="text"
              [attr.disabled]="!detailsData.allowEdit ? '' : null" />
          </div>
          <div *ngFor="let object of item.data" class="details-permission-section">
            <div *ngIf="object.field === 'permissionGranted'" class="grant-permission-row">
              <div class="field-label">{{ 'overview.details-data.data-rows.' + object.field | translate }}</div>
              <div class="grant-permission-row-buttons">
                <button
                  (click)="verifyForm(true)"
                  [class.inactive-button]="isFormRejected"
                  id="details-btn-grant"
                  [disabled]="!detailsData.allowEdit"
                  label="{{ 'yes-button-label' | translate }}"
                  pButton
                  type="button"></button>
                <button
                  (click)="verifyForm(false)"
                  [class.inactive-button]="!isFormRejected"
                  class="no-button"
                  id="details-btn-reject"
                  [disabled]="!detailsData.allowEdit"
                  label="{{ 'no-button-label' | translate }}"
                  pButton
                  type="button"></button>
              </div>
            </div>
            <div *ngIf="object.field === 'permissionGrantedUntil'" class="permission-until-row">
              <div class="flex-align-center" *ngIf="isFormRejected && detailsFormGroup.get('reasonDescription')">
                <label class="field-label required">
                  {{ 'overview.details-data.data-rows.reason-for-rejection' | translate }}
                </label>
                <textarea
                  class="input-field-margin"
                  cols="25"
                  formControlName="reasonDescription"
                  maxlength="400"
                  [disabled]="!detailsData.allowEdit"
                  id="details-textarea-reason"
                  pInputTextarea
                  rows="5"></textarea>
              </div>

              <div class="flex-align-center" *ngIf="!isFormRejected && detailsFormGroup.get('permissionUntil')">
                <label class="field-label required">
                  {{ 'overview.details-data.data-rows.' + object.field | translate }}
                </label>
                <p-calendar
                  tabIndex="0"
                  appCalendarEscapeClose
                  [locale]="'app.calendar-settings' | translate"
                  [disabled]="!detailsData.allowEdit"
                  [minDate]="minDate"
                  class="input-field-margin"
                  dataType="string"
                  dateFormat="{{ dateFormat.dateFormat }}"
                  formControlName="permissionUntil"
                  id="details-date-permission-until"
                  placeholder="{{ dateFormat.placeholder }}"></p-calendar>
              </div>

              <button
                *ngIf="detailsData.allowEdit"
                (click)="updateFormData()"
                [disabled]="detailsSubmitButtonStatus"
                id="details-btn-submit"
                label="{{ isFormRejected ? ('reject-button-label' | translate) : ('grant-button-label' | translate) }}"
                pButton
                type="button"></button>
            </div>
          </div>
        </div>
      </ng-container>
    </form>
  </div>
</div>

<div class="ui-g-12 action-buttons-section">
  <div class="ui-g-6 button-rows left-align">
    <button (click)="back()" class="cancel-button" pButton type="button" label="{{ 'back' | translate }}"></button>
  </div>
  <div class="ui-g-6 button-rows right-align">
    <ng-container *ngIf="detailsData?.allowEdit && !detailsData?.isEmployeeOverview">
      <button
        (click)="saveTechnicianApplicationData()"
        [disabled]="disableSubmitButton"
        class="submit-button"
        id="appln-btn-submit"
        label="{{ 'change-password.submit-button-label' | translate }}"
        pButton
        type="button"></button>

      <button
        (click)="resetFormData()"
        class="cancel-button"
        id="appln-btn-cancel"
        label="{{ 'change-password.cancel-button-label' | translate }}"
        pButton
        type="button"></button>
    </ng-container>
  </div>
</div>

<app-loader *ngIf="isLoading"></app-loader>
